module.exports = __webpack_public_path__ + "img/leveler-2-on.a16eeab9.png";